<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/app-banner/table/">banner管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">日志列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/app-banner/table'">
          <el-button type="primary"
                     size="small">返回
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="admin_name"
                         label="管理员姓名"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="desc"
                         label="修改内容"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="created_at"
                         label="修改时间"
                         min-width="120">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../app-banner.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: 'banner管理ID',
        },
        {
          key: 'name',
          text: 'banner管理名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getAppBannerLogs', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportAppBannerData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteAppBannerData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/app-banner/pages/AppBannerLogTable.vue